<template>
  <div class="soar-container flex gap-3 flex-col">
    <CollapsibleSection
      :key="key"
      :header-label="$t('myFileInformationForSponsored')"
      body-class="w-full flex flex-wrap "
    >
      <div :key="key" v-for="(row, key) in sectionData" class="w-full md:w-1/2 flex flex-row gap-2">
        <span>{{ $t(row.label) }} :</span>
        <span class="text-gray-600">{{ row.value }}</span>
      </div>
      <div class="flex justify-end items-center w-full mt-2">
        <FilledButton v-if="!isNotAllowPrint" @click="printHandle" class="px-5 py-1.5 text-white">
          {{ $t('print') }}
        </FilledButton>
      </div>
    </CollapsibleSection>
    <SponsoredFilesTable
      :tableData="fileInfos"
      :initialValues="initialValues"
      :modules="modules"
      :administrativeRegions="administrativeRegions"
      :fileStatus="fileStatus"
      :transaction="transaction"
    />
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import CollapsibleSection from '@/components/Ui/CollapsibleSection.vue'
import FilledButton from '@/components/Buttons/Filled.vue'

import apiHelperService from '@/services'
import lookup from '@/assets/json/clientLookups.json'

import SponsoredFilesTable from '@/views/individual/sponsored/SponsoredFilesTable.vue'

const route = useRoute()
const sectionData = ref([])
const modules = ref([])
const administrativeRegions = ref([])
const fileStatus = ref([])
const transaction = ref([])
const isNotAllowPrint = ref(true)
const initialValues = ref({
  pageSize: 10,
  currentPage: 1
})
const fileInfos = ref([])

const printHandle = () => {}

const getLookupText = (entry, id, key) => {
  return entry.find((v) => (key ? v[key] == id : v?.id == id))?.text || ''
}
const fetchDataSource = async () => {
  modules.value = await apiHelperService.get('/api/lookup/modules')
  transaction.value = await apiHelperService.get('/api/lookup/transactions')
  administrativeRegions.value = await apiHelperService.get('/api/lookup/departments')
  fileStatus.value = await apiHelperService.get('/api/lookup/fileStatus')
}
const fetchData = async () => {
  let res = await apiHelperService.get(
    `/api/individual/getAllFilesInfoForSponsored/${route.query.sponsoredUnifiedNumber}`
  )
  if (!res) {
    return
  }

  const currentFileInfo = res.find((a) => a.isCurrentFile)
  fileInfos.value = {
    collection: res.filter((a) => !a.isCurrentFile)
  }

  sectionData.value = [
    {
      label: 'ArabicName',
      value: currentFileInfo.fullNameArabic
    },
    {
      label: 'EnglishName',
      value: currentFileInfo.fullNameEnglish
    },
    {
      label: 'FileModuleVisaOrResidency',
      value: getLookupText(modules.value, currentFileInfo.moduleID)
    },
    {
      label: 'fileNumber',
      value: `${currentFileInfo.fileClass}/${currentFileInfo.fileYear}/${currentFileInfo.fileCode}/${currentFileInfo.fileSeq}`
    },
    {
      label: 'issuingPlace',
      value: getLookupText(administrativeRegions.value, currentFileInfo.issueImmigDeptID)
    },
    {
      label: 'fileStatus',
      value: getLookupText(fileStatus.value, currentFileInfo.fileStatus)
    },
    {
      label: 'EmiratesID',
      value: currentFileInfo.eidNumber
    },
    {
      label: 'unifiedNumber',
      value: currentFileInfo.unifiedNumber
    },
    {
      label: 'fileIssueDate',
      value: currentFileInfo.fileIssueDate
    },
    {
      label: 'fileExpireDate',
      value: currentFileInfo.fileExpireDate
    }
  ]
}

const setIsNotAllowPrint = () => {
  const {
    ServiceTransactions: { VisaParentForDomesticHelper, ResidentParentForDomesticHelper }
  } = lookup

  isNotAllowPrint.value = [VisaParentForDomesticHelper, ResidentParentForDomesticHelper].includes(
    route.query.moduleParentService
  )
}

onMounted(async () => {
  try {
    await fetchDataSource()
    setIsNotAllowPrint()
  } catch (error) {
    console.error('fetch data source error', error)
  }
  fetchData()
})
</script>
